import React from 'react';

import ArchivesFilters from '../ArchivesFilters/ArchivesFilters';
import styles from '../css/Archives.module.css';


function ArchivesHeader(props) {
  return (
    <React.Fragment>
      <header className={styles.header}>
        <div className={styles.headerContainer}>
          <div className={styles.headerTitle}>
            <h1>NAKED NEWS ARCHIVE</h1>
          </div>
          <p className={styles.description}>
            The Naked News Archives are made up of thousands of past shows.
            <br />
            Don&apos;t miss a day by watching the Best Of Naked News now.</p>
          <ArchivesFilters {...props} />
        </div>
      </header>
    </React.Fragment>
  );
}

export default ArchivesHeader;
